import { MessageCircle } from 'lucide-react';
import { waLink, DEFAULT_WA_MESSAGE, INSTAGRAM_URL, INSTAGRAM } from '../data/site';

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/10 bg-[#0B0C10] py-12"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="flex flex-col items-center sm:items-start leading-none">
        <span className="font-display font-extrabold text-lg tracking-tight text-white">
          DAVY
        </span>
        <span className="text-[10px] font-mono tracking-[0.3em] text-blue-400 uppercase mt-1">
          Despachante · Betim/MG
        </span>
      </div>

      <p className="text-[11px] text-slate-500 text-center max-w-md leading-relaxed">
        Serviço privado de despachante. Sem vínculo com o DETRAN-MG.
        <br />© 2026 Davy Despachante. Todos os direitos reservados.
      </p>

      <div className="flex items-center gap-4">
        <a
          data-testid="footer-instagram-link"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-slate-400 hover:text-blue-400 transition-colors"
        >
          {INSTAGRAM}
        </a>
        <a
          data-testid="footer-whatsapp-link"
          href={waLink(DEFAULT_WA_MESSAGE)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border border-white/15 hover:border-blue-400/60 rounded-full px-4 py-2 text-xs font-semibold text-slate-200 hover:text-blue-400 transition-colors"
        >
          <MessageCircle size={13} />
          WhatsApp
        </a>
      </div>
    </div>
  </footer>
);
